import {Directive, HostListener, Input} from '@angular/core';
import {ToolsService} from '../services/tools.service';
import {StaticAdDataset} from '../types/StaticAdDataset';
import {GtmEventEnum} from '../enums/GoogleEnums';
import {GtmService} from '../services/gtm.service';
import {GtmGa4EventPushService} from '../services/gtm-ga4-event-push.service';
import {DataLayerParamsClickGA4} from '../types/DataLayerParamsClickGA4';

@Directive({
  selector: '[appStaticAdClick]',
})
export class StaticAdClickDirective {
  @Input() dataLayerParamsClickGA4: DataLayerParamsClickGA4;
  private staticAdCssClassName = 'static-ad-click';

  constructor(
    private gtmService: GtmService,
    private gtmEventPush: GtmGa4EventPushService,
    private tools: ToolsService
  ) {}

  @HostListener('click', ['$event'])
  onClick(e) {
    if (
      !this.tools.isNil(e) &&
      !this.tools.isNil(e.target) &&
      e.target.className.indexOf(this.staticAdCssClassName) >= 0
    ) {
      const dataset: StaticAdDataset = this.prepareDataset(e.target);
      this.clickRegister(dataset);
      this.ga4EventRegister(dataset);
    }
  }

  private clickRegister(dataset: StaticAdDataset): void {
    const gtmTag = {
      event: GtmEventEnum.DEFAULT,
      Category: dataset.adname,
      Action: dataset.adaction,
      Label: dataset.adlabel,
      Value: dataset.advalue,
    };
    this.gtmService.pushTag(gtmTag);
  }

  private prepareDataset(target): StaticAdDataset {
    const dataset: StaticAdDataset = {
      adname:
        !this.tools.isNil(target.dataset) && !this.tools.isNil(target.dataset.adname)
          ? target.dataset.adname
          : 'unknown',
      adaction:
        !this.tools.isNil(target.dataset) && !this.tools.isNil(target.dataset.adaction) ? target.dataset.adaction : '',
      adlabel:
        !this.tools.isNil(target.dataset) && !this.tools.isNil(target.dataset.adlabel) ? target.dataset.adlabel : '',
      advalue:
        !this.tools.isNil(target.dataset) && !this.tools.isNil(target.dataset.advalue) ? target.dataset.advalue : 1,
      adimpnointeraction:
        !this.tools.isNil(target.dataset) && !this.tools.isNil(target.dataset.adimpnointeraction)
          ? target.dataset.adimpnointeraction
          : true,
    };

    if (!this.tools.isNil(this.dataLayerParamsClickGA4)) {
      const keys = Object.keys(this.dataLayerParamsClickGA4);
      keys.forEach((key) => {
        if (!this.tools.isNil(this.dataLayerParamsClickGA4[key])) {
          dataset[key] = this.dataLayerParamsClickGA4[key];
        }
      });
    }

    if (!this.tools.isNil(target.dataset)) {
      if (!this.tools.isNil(target.dataset.calltoaction)) {
        dataset.callToAction = target.dataset.calltoaction;
      }
      if (!this.tools.isNil(target.dataset.bookingtype)) {
        dataset.bookingType = target.dataset.bookingtype;
      }
      if (!this.tools.isNil(target.dataset.inferredcareprovidertypeareaid)) {
        dataset.inferredCareProviderTypeAreaId = target.dataset.inferredcareprovidertypeareaid;
      }
      if (!this.tools.isNil(target.dataset.inferredcategorytypeid)) {
        dataset.inferredCategoryTypeId = target.dataset.inferredcategorytypeid;
      }
      if (!this.tools.isNil(target.dataset.maincareprovidertypeid)) {
        dataset.mainCareProviderTypeId = target.dataset.maincareprovidertypeid;
      }
      if (!this.tools.isNil(target.dataset.careserviceid)) {
        dataset.careServiceId = target.dataset.careserviceid;
      }
      if (!this.tools.isNil(target.dataset.careservicetypeid)) {
        dataset.careServiceTypeId = target.dataset.careservicetypeid;
      }
      if (!this.tools.isNil(target.dataset.cpruid)) {
        dataset.cpruId = target.dataset.cpruid;
      }
      if (!this.tools.isNil(target.dataset.treatmentid)) {
        dataset.treatmentId = target.dataset.treatmentid;
      }
    }
    return dataset;
  }

  private ga4EventRegister(dataset: StaticAdDataset): void {
    const customGa4Params: DataLayerParamsClickGA4 = {
      callToAction:
        dataset.callToAction != null && dataset.callToAction !== ''
          ? dataset.callToAction
          : `${dataset.adname} ${dataset.adaction}`,
      pageType: dataset.pageType,
    };

    if (!this.tools.isNil(dataset.bookingType)) {
      customGa4Params.bookingType = dataset.bookingType;
    }
    if (!this.tools.isNil(dataset.inferredCareProviderTypeAreaId)) {
      customGa4Params.inferredCareProviderTypeAreaId = dataset.inferredCareProviderTypeAreaId;
    }
    if (!this.tools.isNil(dataset.inferredCategoryTypeId)) {
      customGa4Params.inferredCategoryTypeId = dataset.inferredCategoryTypeId;
    }
    if (!this.tools.isNil(dataset.mainCareProviderTypeId)) {
      customGa4Params.mainCareProviderTypeId = dataset.mainCareProviderTypeId;
    }
    if (!this.tools.isNil(dataset.careServiceId)) {
      customGa4Params.careServiceId = dataset.careServiceId;
    }
    if (!this.tools.isNil(dataset.careServiceTypeId)) {
      customGa4Params.careServiceTypeId = dataset.careServiceTypeId;
    }
    if (!this.tools.isNil(dataset.cpruId)) {
      customGa4Params.cpruId = dataset.cpruId;
    }
    if (!this.tools.isNil(dataset.treatmentId)) {
      customGa4Params.treatmentId = dataset.treatmentId;
    }

    const gtmGa4Tag = {
      event: GtmEventEnum.CTA_CLICK,
      ...customGa4Params,
    };
    this.gtmEventPush.pushClickEvent(gtmGa4Tag);
  }
}
